import { AppAction, FSA } from '@typings/redux';

export const isFSA = (action: AppAction): action is FSA => {
  return Object.prototype.hasOwnProperty.call(action, 'type');
};
